var map = {
	"./404.svg": 45086,
	"./address-line.svg": 59985,
	"./address-name.svg": 22782,
	"./address-phone.svg": 68801,
	"./balance.svg": 49398,
	"./benefits.svg": 31166,
	"./bug.svg": 15204,
	"./chart.svg": 774,
	"./clipboard.svg": 52512,
	"./component.svg": 37151,
	"./credit.svg": 40329,
	"./dashboard.svg": 26978,
	"./documentation.svg": 48832,
	"./download.svg": 42682,
	"./drag.svg": 7376,
	"./edit.svg": 67718,
	"./education.svg": 41284,
	"./email.svg": 69758,
	"./example.svg": 32056,
	"./excel-download.svg": 30708,
	"./excel.svg": 97379,
	"./exit-fullscreen.svg": 82676,
	"./export.svg": 37404,
	"./eye-open.svg": 98658,
	"./eye.svg": 2269,
	"./form.svg": 99904,
	"./fullscreen.svg": 25553,
	"./guide.svg": 57338,
	"./ic_down.svg": 75065,
	"./ic_search.svg": 93389,
	"./ic_up.svg": 77430,
	"./icon-Balance.svg": 62170,
	"./icon-Charts.svg": 71157,
	"./icon-Credit.svg": 88469,
	"./icon-Unpaid-Order.svg": 78910,
	"./icon-addfriends.svg": 36602,
	"./icon-delete.svg": 17519,
	"./icon-ic_address_address_ic_address_address.svg": 24709,
	"./icon-ic_address_name_Desktop.svg": 44230,
	"./icon-ic_address_phone_Desktop.svg": 40383,
	"./icon-ic_commission.svg": 62298,
	"./icon-ic_record2.svg": 33248,
	"./icon-ic_screenshot.svg": 7885,
	"./icon-ic_withdrawal.svg": 74700,
	"./icon-icome.svg": 32999,
	"./icon-note.svg": 78962,
	"./icon-orders.svg": 65025,
	"./icon.svg": 47233,
	"./icon_add.svg": 43165,
	"./icon_error.svg": 36638,
	"./icon_face.svg": 65247,
	"./income.svg": 42407,
	"./international.svg": 15878,
	"./inventory.svg": 34718,
	"./invite.svg": 92245,
	"./language.svg": 30452,
	"./link.svg": 7530,
	"./list.svg": 48574,
	"./logo-mini.svg": 54953,
	"./logo.svg": 16515,
	"./logo1.svg": 94664,
	"./logout.svg": 20064,
	"./message.svg": 38447,
	"./method.svg": 45049,
	"./money.svg": 63986,
	"./nested.svg": 3107,
	"./note.svg": 47841,
	"./order.svg": 72810,
	"./password.svg": 34665,
	"./paypal.svg": 14983,
	"./pdf-download.svg": 28853,
	"./pdf.svg": 29132,
	"./people.svg": 54975,
	"./peoples.svg": 11550,
	"./product.svg": 21543,
	"./qq.svg": 98652,
	"./record.svg": 82193,
	"./search.svg": 17522,
	"./setting.svg": 24734,
	"./shopcart.svg": 69632,
	"./shopping.svg": 12526,
	"./size.svg": 92197,
	"./skill.svg": 52029,
	"./sourcing.svg": 59567,
	"./star.svg": 64002,
	"./store.svg": 80405,
	"./subtract.svg": 53566,
	"./support.svg": 21599,
	"./tab.svg": 51519,
	"./table.svg": 81222,
	"./theme.svg": 40189,
	"./tree-table.svg": 46461,
	"./tree.svg": 75030,
	"./triangle.svg": 706,
	"./user.svg": 25955,
	"./wallet.svg": 95429,
	"./wechat.svg": 23196,
	"./zip.svg": 74975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73870;